import { Navigate, createFileRoute } from '@tanstack/react-router'
import { messageQueryOptions } from '~/queries'

export const Route = createFileRoute('/workspaces/$workspaceId/bots/$botId/conversationIdQuery/$messageId')({
  component: Component,
  loader: ({ context, params }) => {
    const { messageId, botId, workspaceId } = params
    return context.queryClient.ensureQueryData(messageQueryOptions({ messageId: messageId, botId, workspaceId }))
  },
})

function Component() {
  const { workspaceId, botId } = Route.useParams()
  const message = Route.useLoaderData().message
  return (
    <Navigate
      to="/workspaces/$workspaceId/bots/$botId/conversations/$conversationId/messages/$messageId"
      params={{ workspaceId, botId, conversationId: message.conversationId, messageId: message.id }}
    />
  )
}
